(function($){
    
    let animationFile = "//sugabeast.de/cdn/shop/t/14/assets/hurray-animation.json?v=23786126344980450891785747572";

    // $(".remove_section_event").on('recommendations:empty', function (e) {
    //     $(this).closest('.shopify-section').remove();
    // });

    window.playDrawerAnimation = function (count = 1) {
        animateCartLottie();
        for (let index = 1; index < count; index++) {
            setTimeout(() => {
                animateCartLottie();
            }, 800);
        }
    }

    function animateCartLottie() {
        var wrapper = document.getElementById("hurray-container");
        if (!wrapper) return;
        wrapper.style.display = "block";
        var container = document.createElement("div");
        container.style.position = "absolute";
        container.style.top = 0;
        container.style.left = 0;
        container.style.width = "100%";
        container.style.height = "100%";
        container.style.pointerEvents = "none";

        wrapper.appendChild(container);

        var animation = lottie.loadAnimation({
            container: container,
            renderer: "svg",
            loop: false,
            autoplay: true,
            path: animationFile
        });

        animation.addEventListener("complete", function () {
            animation.destroy();
            container.remove(); // clean up
        });
    }

    document.querySelectorAll('.allow-auto-scroll .section__content').forEach(el => {
        el._isHovered = false;

        el.addEventListener('mouseenter', () => {
            el._isHovered = true;
        });

        el.addEventListener('mouseleave', () => {
            el._isHovered = false;
        });
    });

    function allowAutoScroll() {
        document.querySelectorAll('.allow-auto-scroll').forEach(wrapper => {
            const content = wrapper.querySelector('.section__content');
            if (content && !content._isHovered) {
                const btn = wrapper.querySelector('.swiper-btn-next');
                if (btn) {
                    btn.dispatchEvent(
                        new CustomEvent('click', {
                            bubbles: true,
                            detail: { source: 'auto' }
                        })
                    );
                }
            }
        });

        setTimeout(allowAutoScroll, 3000);
    }

    if (!localStorage.getItem("firstVisitReloaded")) {
        localStorage.setItem("firstVisitReloaded", "true");
        location.reload();
    }

    allowAutoScroll();

    document.addEventListener('click', function (e) {
        const $target = $(e.target).closest('.jdgm-widget.jdgm-preview-badge--with-link');
        if (!$target.length) return;

        // console.log('Capture phase hit');
        const row = document.getElementById('review-collapsible-row');
        if (!row) return;

        const details = row.querySelector('.accordion-details');
        if (details && !details.hasAttribute('open')) {
           $('#review-collapsible-row .accordion-details .accordion-details__summary').trigger('click');
        }

        const headerOffset = 80; // adjust to your header height
        const elementPosition = row.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        setTimeout(() => {
            row.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 250);
        
        // $('#review-collapsible-row .accordion-details .accordion-details__summary').get(0)?.click(); // native click

    }, true); // ✅ capture phase

    function whenSwiperReady(callback) {
        const check = setInterval(() => {
            document.querySelectorAll('.swiper').forEach(el => {
            if (el.swiper) {
                clearInterval(check);
                callback();
            }
            });
        }, 300);
    }

    document.addEventListener('DOMContentLoaded', () => {
        updateCardWidth();
        setTimeout(() => {
            updateCardWidth();
        }, 300);
    });

    function patchSwiperParams(swiper) {
        if (!swiper) return;

        /* AUTOPLAY */
        swiper.params.autoplay = {
        delay: 0,
        pauseOnMouseEnter: true,
        disableOnInteraction: true
        };

        swiper.autoplay?.start();

        /* SPEED */
        swiper.params.speed = 1000;

        /* SLIDES PER VIEW / SPACING */
        swiper.params.slidesPerView = 'auto';
        swiper.params.spaceBetween = 10;

        /* CENTERED */
        swiper.params.centeredSlides = true;

        /* NAVIGATION OFF */
        swiper.params.navigation = false;
    }

    function enableLoop(swiper) {
        if (swiper.params.loop) return;

        swiper.params.loop = true;
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideToLoop(swiper.activeIndex, 0);
    }

    function reinitSwiperCarousel() {
        document.querySelectorAll('.sd-apps-section .spark-carousal-root .swiper').forEach(swiperEl => {
            const swiper = swiperEl.swiper;
            if (!swiper) return;

            swiper.destroy(true, false);
            const wrapper = swiperEl.querySelector('.swiper-wrapper');
            if (!wrapper) return;

            // get all existing slides
            const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

            // duplicate each slide and append to the wrapper
            slides.forEach(slide => {
                const clone = slide.cloneNode(true); // deep clone
                wrapper.appendChild(clone);
            });
            new Swiper ('.sd-apps-section .spark-carousal-root .swiper', {
                autoplay: {
                    enabled: true,
                    delay: 0,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: true,
                },
                centeredSlides: true,
                loop: true,
                navigation: false,
                noSwipingClass: 'swiper-slide',
                slidesPerView: 'auto',
                spaceBetween: 10,
                speed: 6000,
            });
        });
    }

    function updateCardWidth() {

        $('.products-list, .products-grid').each(function () {
            let $grid = $(this);
            const styles = getComputedStyle($grid[0]);
            const cols = parseInt(styles.getPropertyValue('--col-number'));
            const gap = parseFloat(styles.getPropertyValue('--column-gap'));

            const gridWidth = $grid.width();
            const totalGap = (cols - 1) * gap;
            const cardWidth = (gridWidth - totalGap) / cols;

            $grid.find('.f-column').css('--card-width', cardWidth + 'px');
        });

        $('.product-card__image-wrapper').each(function(){
            let $grid = $(this);
            const gridWidth = $grid.width();
            $grid.parents('.product-card__wrapper').css('--card-image-width', gridWidth + 'px');
        });
    }

    // Initial calculation
    updateCardWidth();

    // On window resize
    let updateCardWidthDebounced;
    $(window).on('resize', function(){
        if (!updateCardWidthDebounced) updateCardWidthDebounced = debounce(updateCardWidth, 200);
        updateCardWidthDebounced();
    });
    
    let runCount = 0;
    const maxRuns = 10;

    function calculateHeadingViewBox()
    {
        if (runCount >= maxRuns) return;
        document.querySelectorAll('.badge').forEach(svg => {
            const texts = svg.querySelectorAll('text');
            let maxWidth = 0;
            let maxHeight = 0;
            texts.forEach(t => {
                const bbox = t.getBBox();
                maxWidth = Math.max(maxWidth, bbox.x + bbox.width);
                maxHeight = Math.max(maxHeight, bbox.y + bbox.height);
            });
            svg.setAttribute("viewBox", `0 0 ${maxWidth + 20} ${maxHeight + 20}`);
        });
        runCount++;
        setTimeout(() => {
            calculateHeadingViewBox();
        }, 1000);
    }
    
    document.addEventListener('DOMContentLoaded', () => {
        calculateHeadingViewBox();
    });

    function animateTextSection() {
        const lines = [
            [
                { text: "die neusten candy-trends", class: "normal" },
            ],
            [
                { text: "aus", class: "normal" },
                { text: " ", class: "normal" },   
                { text: "aller welt!", class: "bigger" }
            ]
        ];

        const textElement = document.getElementById("animatedText");

        if (!textElement) return;
        
        lines.forEach((line, lineIndex) => {
            line.forEach((wordObj, wordIndex) => {
                wordObj.text.split("").forEach((letter, letterIndex) => {
                    const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                    // reset x for each line
                    if (letterIndex === 0 && wordIndex == 0) {
                        tspan.setAttribute("x", lineIndex === 0 ? "20" : "120");
                        tspan.setAttribute("dy", lineIndex === 0 ? "0" : "0.9em");
                    }
                    if (letterIndex == 0 && wordObj.class == "bigger") {
                        tspan.setAttribute("dy", "0.3em");
                    }
                    tspan.classList.add(wordObj.class);
                    tspan.textContent = letter === " " ? "\u00A0" : letter;
                    textElement.appendChild(tspan);
                });
            });
        });
    }

    animateTextSection();

    function wrapLetters(node) {
        $(node).contents().each(function () {
            // If text node → wrap each character
            if (this.nodeType === 3) {
                const text = this.nodeValue;
                const wrapped = text.split('').map(char => {
                return char.trim() === ''
                    ? char
                    : `<letter>${char}</letter>`;
                }).join('');

                $(this).replaceWith(wrapped);
            }

            // If element node → recurse
            else if (this.nodeType === 1) {
                wrapLetters(this);
            }
        });
        initLetterScrollAnimation();
    }
    
    function initZigzagAnimation() {
        let mm = gsap.matchMedia();
        mm.add("(min-width: 768px)", () => {
            gsap.utils.toArray(".zigzag-heading-wrapper .animate-box").forEach((el) => {
                const wrapper = el.closest(".zigzag-heading-wrapper");
                // Check if element is already visible on load
                const rect = wrapper.getBoundingClientRect();
                const isVisibleOnLoad = (rect.top - 80) < window.innerHeight && rect.bottom > 0;
                // console.log(rect.top, window.innerHeight, rect.bottom, isVisibleOnLoad);
                const elementWidth = el.clientWidth;
                const fromLeft = wrapper.classList.contains("align-left");
                // If visible → keep at original position and skip animation
                if (isVisibleOnLoad) {
                    gsap.set(el, { x: 0 });
                    return;
                }
                gsap.fromTo(el, {
                        x: fromLeft ? -200 : 200,
                    },
                    {
                        x: 0,
                        duration: 1, // ⬅️ real slowdown
                        ease: "power3.out",
                        scrollTrigger: {
                            trigger: wrapper,
                            start: "top bottom",
                            end: "top 70%",
                            scrub: 1.5,
                            invalidateOnRefresh: true
                        }
                    }
                );
            });
        });
    }

    function initLetterScrollAnimation() {
        const section = document.querySelector(".letter-animate");
        const letters = document.querySelectorAll("#animatedText tspan");
        if (!letters.length) return;
        // Initial state
        gsap.set(letters, { opacity: 0.3 });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 60%",
                end: "top 20%",
                scrub: true
            }
        });
        tl.to(letters, {
            opacity: 1,
            stagger: 1,
            ease: "none",
            duration: 1
        });
    }

    function fetchProductInfoUsingGraph()
    {
        var storefrontAccessToken = "9a133b43195a7b26955c6acd17088227";
        var productId = $('product-info').data('product-id');

        // Stop if no product ID found
        if (!productId) {
            // console.log("No product ID found. API not called.");
            return;
        }

        // Convert numeric ID → GraphQL GID
        var productGid = "gid://shopify/Product/" + productId;
        var shopDomain = Shopify.shop;

        $.ajax({
            url: "https://" + shopDomain + "/api/2024-01/graphql.json",
            type: "POST",
            headers: {
            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            "Content-Type": "application/json"
            },
            data: JSON.stringify({
            query: `
                query {
                product(id: "${productGid}") {
                    title
                    bundleComponents(first: 10) {
                    edges {
                        node {
                        quantity
                        product {
                            title
                            handle
                        }
                        }
                    }
                    }
                }
                }
            `
            }),
            success: function(response) {
                // console.log(response);

                var components = response?.data?.product?.bundleComponents?.edges;

                if (components && components.length > 0) {
                    components.forEach(function(component){
                        // console.log(
                        //     component.node.quantity + " × " +
                        //     component.node.product.title
                        // );
                    });
                }
            },
            error: function(error) {
                console.error(error);
            }
        });
    }

    // fetchProductInfoUsingGraph();

    // function updatePushOwlButton() {
    //     const btn = document.querySelector('.pushowl-optin-button .button-content');

    //     if (btn) {
    //         btn.textContent = "Subscribe Now";
    //         return true;
    //     }
    //     return false;
    // }

    // if (document.body.classList.contains('template-product')) {
    //     let attempts = 0;

    //     const interval = setInterval(() => {
    //         const done = updatePushOwlButton();

    //         attempts++;
    //         if (done || attempts > 20) {
    //             clearInterval(interval);
    //         }
    //     }, 500);
    // }

    if (document.body.classList.contains('product-template') && Shopify.locale == 'en') {

        const pushform_target = document.querySelector('.pushowl-brevo-bis-form');
        let host_target = null;
        const form_observer = new MutationObserver(() => {
            const btn = document.querySelector('.pushowl-optin-button .button-content');
            console.log("MutationObserver Running");
            if (btn) {
                btn.textContent = "Notify me when available";
                form_observer.disconnect();

                host_target = document.querySelector('#pushowl-bis-shadow-host');
                host_observer.observe(host_target, {
                    childList: true,
                    subtree: true
                });
            }
        });

        form_observer.observe(pushform_target, {
            childList: true,
            subtree: true
        });

        const host_observer = new MutationObserver(() => {
            console.log("Host Observer Running");
            if (host_target) {
                const shadow = host_target;
                // Title
                const title = shadow.querySelector('#title');
                if (title) {
                    title.textContent = "Get notified when this product is back in stock";
                }

                const subtitle = shadow.querySelector('#subtitle');
                if (subtitle) {
                    subtitle.textContent = "You will be notified as soon as the product is available again.";
                }

                // Email placeholder
                const emailInput = shadow.querySelector('#email');
                if (emailInput) {
                    emailInput.placeholder = "Enter your email address";
                }

                // Submit button
                const submitBtn = shadow.querySelector('button[name="submit"] .button-content');
                if (submitBtn) {
                    submitBtn.textContent = "Notify me when available";
                }

                if ((title && emailInput && submitBtn) || (title && subtitle)) {
                    host_observer.disconnect();
                }
            }
        });

        $(document).on('click', '.pushowl-optin-dismiss-button, form.pushowl-bis-form-container button[type="submit"]', function(){
            host_observer.observe(host_target, {
                childList: true,
                subtree: true
            });
        });
    }

    const relatedProducts = document.querySelector('.related-products');

    // Debounce to prevent excessive calls
    const debounce = (fn, delay = 100) => {
        let t;
        // console.log("debounced");
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...args), delay);
        };
    };

    const update = debounce(updateCardWidth, 200);

    if (relatedProducts) {
        // ResizeObserver (runs when size changes)
        const relatedProductsResizeObserver = new ResizeObserver(update);
        relatedProductsResizeObserver.observe(relatedProducts);

        // MutationObserver (runs once when content is injected)
        const relatedProductsMutationObserver = new MutationObserver((mutations, observer) => {
            if (relatedProducts.children.length > 0) {
                update();
                observer.disconnect(); // run only once
            }
        });

        relatedProductsMutationObserver.observe(relatedProducts, {
            childList: true,
            subtree: true
        });
    }

    $(document).on('click', '.cart-template .cart-bundle-product-list .product-count-info', function(){
        const $el = $(this).parent().find('.bundle-products-list');
        $el.stop(true, true).slideToggle(300, function () {
            const visible = $(this).is(':visible');
            $(this).parent().toggleClass('is-visible', visible).toggleClass('is-hidden', !visible);
        });
    });
})(jQuery);